function successBusinessSend(data) {
    let res = data.trim();

    if (res === 'success') {
        $('#businessModal').modal('show');
        $('form').trigger('reset').removeClass('was-validated');
    } else {
    }
}
